module.exports = {
          srcSet: __webpack_public_path__ + "913945ae49955b6ff4522d0c0b01b112-886.png"+" 886w",
          images:[ {path: __webpack_public_path__ + "913945ae49955b6ff4522d0c0b01b112-886.png",width: 886,height: 390}],
          src: __webpack_public_path__ + "913945ae49955b6ff4522d0c0b01b112-886.png",
          toString:function(){return __webpack_public_path__ + "913945ae49955b6ff4522d0c0b01b112-886.png"},
          
          width: 886,
          height: 390
        }